import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/betgalaxy/images/logo.svg';

export default function index() {
  return <Image src={footerLogo} maxW="174px" />;
}
